var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5246_62272)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0477 5.95267C16.5242 4.42917 14.0541 4.42917 12.5306 5.95267L4.96622 13.5171C3.98764 14.4957 3.98764 16.0822 4.96622 17.0608C5.9448 18.0394 7.53139 18.0394 8.50997 17.0608C8.51017 17.0606 8.51038 17.0604 8.51058 17.0602L14.7588 10.812C15.1925 10.3783 15.1925 9.67521 14.7588 9.24154C14.3252 8.80788 13.6221 8.80788 13.1884 9.24154L7.9262 14.5037C7.63331 14.7966 7.15843 14.7966 6.86554 14.5037C6.57265 14.2108 6.57265 13.736 6.86554 13.4431L12.1277 8.18088C13.1472 7.16143 14.8 7.16143 15.8195 8.18088C16.8389 9.20033 16.8389 10.8532 15.8195 11.8726L9.57063 18.1215C9.57006 18.1221 9.56949 18.1226 9.56892 18.1232C8.00441 19.6859 5.46935 19.6853 3.90556 18.1215C2.34119 16.5571 2.34119 14.0208 3.90556 12.4564L11.47 4.89201C13.5792 2.78273 16.9991 2.78273 19.1084 4.89201C21.2176 7.0013 21.2176 10.4211 19.1084 12.5304L13.1884 18.4504C12.8955 18.7433 12.4206 18.7433 12.1277 18.4504C11.8348 18.1575 11.8348 17.6826 12.1277 17.3897L18.0477 11.4698C19.5712 9.94625 19.5712 7.47617 18.0477 5.95267Z",
    fill: "#081B3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5246_62272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.d1704b41c53ab1de72c958381fef11c9.svg";
export { ForwardRef as ReactComponent };